// extracted by mini-css-extract-plugin
export default {"ace-c-ace-logo":"ace-logo---420d7984"};